import {
  AddSurveyType,
  Page,
  ShortOfferType, SurveyType,
} from "@jobintrans/base-ui.types.api"
import { API_URL, APIService } from "./APIService"

const getSurveys = (page: number) =>
  APIService.get<null, Page<SurveyType>>(`/profiles/:profileId/surveys?page=${page}`)

const searchSurveys = (q: string) =>
    APIService.get<null, Page<SurveyType>>(`/profiles/:profileId/short-surveys?q=${q}`)


const addSurvey = (body: AddSurveyType) =>
    APIService.post<null, SurveyType>(`/profiles/:profileId/surveys`, body)


export const ProfileSurveyService = {
  getSurveys,
  addSurvey,
  searchSurveys,
}
